import { render, staticRenderFns } from "./WsDataReadOnlyList.vue?vue&type=template&id=0c381560&"
import script from "./WsDataReadOnlyList.vue?vue&type=script&lang=js&"
export * from "./WsDataReadOnlyList.vue?vue&type=script&lang=js&"
import style0 from "./WsDataReadOnlyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VDivider,VIcon,VSkeletonLoader,VSpacer})
